import * as Sentry from '@sentry/browser';

export const setSentryUser = user => {
  if (user && user.id) {
    Sentry.setUser({
      id: String(user.id),
      username: user.username || user.name,
      email: user.email
    });
  } else {
    Sentry.setUser(null);
  }
};

export const clearSentryUser = () => {
  Sentry.setUser(null);
};

